<template>
  <div id="sellerDiscountCouponPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-badge-percent fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">ایجاد کوپن تخفیف</span>
                </div>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="defineCouponTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showDefineCouponTab">ایجاد کوپن</span>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="listCouponTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showListCouponTab">لیست کوپن</span>
              </div>

            </div>
            <div v-if="defineCouponTab"
                 class="col-12 px-1  text-right">
              <div class="font-weight-bold mb-2">
                درصد تخفیف
              </div>
              <v-text-field
                  v-model="discount"
                  dense
                  flat
                  solo
                  type="number">
              </v-text-field>
              <div class="font-weight-bold mb-2">
                حداکثر تعداد قابل استفاده
              </div>
              <v-text-field
                  v-model="maxUse"
                  dense
                  flat
                  solo
                  type="number">
              </v-text-field>
              <div class="font-weight-bold mb-2">
                تاریخ انقضا
              </div>
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="inputDate"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fa-solid fa-calendar-days"
                      dense
                      flat
                      readonly
                      solo></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    locale="fa-ir"
                    width="256"
                    @input="inputDatePicker"></v-date-picker>
              </v-menu>
              <div class="p-0 font-weight-bold mb-2">
                نوع کد
              </div>
              <v-select
                  v-model="typeDiscount"
                  :items="items"
                  dense
                  flat
                  hide-details
                  item-text="text"
                  item-value="id"
                  solo></v-select>
              <div class="font12px my-2"> در صورت عمومی بودن و لیست دنبال کنندگان ، لیست کاربران در نظر گرفته نمیشود.
              </div>
              <div class="p-0 font-weight-bold my-2 mt-4">
                لیست دنبال کنندگان
              </div>
              <v-autocomplete
                  v-model="friends"
                  :items="people"
                  chips
                  dense
                  filled
                  flat
                  item-text="Text"
                  item-value="Value"
                  label="لیست"
                  multiple
                  solo>
                <template v-slot:selection="data">
                  <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="remove(data.item)">
                    {{ data.item.Text }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.Text"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>

              <div class="font-weight-bold font12px">
                <i class="fa-solid fa-period mr-3"></i> تاریخ انقضا باید از 24 ساعت بعد ار روز جاری حداقل باشد

                <div class="mt-2 font12px"><i class="fa-solid fa-period mr-3"></i> در صورت انتخاب دنبال کنندگان ، تعداد
                  بار مجاز استفاده از کد از حداکثر تعداد ، محاسبه می شود
                </div>

                <div class="font12px my-2"><i class="fa-solid fa-period mr-3"></i> در صورت انتخاب دنبال کننده خاص ،
                  امکان انتخاب چندین دنبال کننده را دارید که در این حالت برای هر دنبال *
                  کننده یک کد انحصاری تولید می گردد
                </div>

                <br><i class="fa-solid fa-period mr-3"></i> در صورت انتخاب دنبال کننده خاص ، هر دنبال کننده فقط یکبار می
                تواند از کد استفاده کند
              </div>
              <div class=" mt-5">
                <v-btn
                    block
                    color="primary"
                    @click="registerDiscountCoupon">
                  ایجاد
                </v-btn>
              </div>
            </div>
            <div v-if="listCouponTab"
                 class="row text-right">

              <div v-if="couponsList.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز کوپنی ثبت نشده است
                </div>

              </div>
              <div v-else class="col-12">
                <div class="row">
                  <div class="col mt-2">
                    <v-text-field
                        v-model="searchKeyWord"
                        append-icon="far fa-magnifying-glass"
                        class="rounded-lg"
                        clearable
                        dense
                        flat
                        hide-details
                        placeholder="...Search Discount"
                        solo
                        @keyup="search"
                        @click:clear="removeSearchHistory">
                    </v-text-field>
                  </div>
                  <div v-if="!hasResult" class="col-12 text-center">
                    نتیجه ای یافت نشد
                  </div>
                  <div v-for="(item,i) in couponsList" v-else :key="i" class="col-12 py-1">
                    <div class="bg-white px-2 py-4 rounded-lg">
                      <div>
                   <span v-if="item.TypeDiscount === 3" class="d-inline-block w-75">
                     <v-avatar size="50">
                          <img v-if="item.VendorFollowerImageUrl !== null"
                               :src="$replaceHttps(item.VendorFollowerImageUrl)" alt="تصویر کاربر">
                          <i v-else class="fas fa-circle-user fa-4x"></i>
                        </v-avatar>
                        <span class="font-weight-bold mr-1">
{{ item.VendorFollowerName.replace(/<\s*\/?br\s*[\/]?>/gi, "") }}
                        </span>
                   </span>
                        <span v-else class="d-inline-block w-75">
                            <v-avatar size="50">
                          <i class="fal fa-users fa-2x"></i>
                        </v-avatar>
                      </span>
                        <span class="d-inline-block w-25 text-left font-weight-bold">
                       <v-btn icon @click="openEditCoupon(item.DiscountCodeID)"><i
                           class="fal fa-pen-to-square fa-2xl"></i></v-btn>
                    </span>
                      </div>
                      <div class="mt-4 my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     نوع کد
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ typeDiscountCode[item.TypeDiscount] }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     شماره کد
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ item.CodeNumber }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     حداکثر تعداد بار قابل استفاده
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ item.MaximumUseNumber }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     تعداد بار استفاده شده
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ item.CountUseNumber }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     درصد تخفیف
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ item.Discount }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     تاریخ درج
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ $convertDate(item.InsertDate) }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     تاریخ انقضا
                   </span>
                        <span class="d-inline-block w-50 text-left font-weight-bold">
                      {{ $convertDate(item.ExpireDate) }}
                    </span>
                      </div>
                      <div class="my-2">
                   <span class="d-inline-block w-50 font-weight-bold">
                     تاریخ استفاده
                   </span>
                        <span v-if="item.IsUse" class="d-inline-block w-50 text-left font-weight-bold">
                      {{ $convertDate(item.UseDate) }}
                    </span><span v-else class="d-inline-block w-50 text-left font-weight-bold">
                   استفاده نشده
                    </span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText">

      </div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-bottom-sheet v-model="openEditBottomSheet" class="bottom-sheet" width="600">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            ویرایش کوپن
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openEditBottomSheet = !openEditBottomSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12">
            <div class="font-weight-bold mb-2">
              حداکثر تعداد استفاده
            </div>
            <v-text-field
                v-model="editMaxUse"
                background-color="secondary"
                dense
                flat
                solo
                type="number">
            </v-text-field>
            <div class="font-weight-bold my-2">
              تاریخ انقضا
            </div>
            <v-menu
                v-model="menu2Dialog"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDateDialog"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="fa-solid fa-calendar-days"
                    background-color="secondary"
                    dense
                    flat
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="dateDialog"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePickerDialog"></v-date-picker>
            </v-menu>
            <v-btn
                class="font-weight-bold"
                color="primary"
                outlined
                small
                @click="editCoupon">
              ویرایش
            </v-btn>
          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
import moment from "moment-jalaali";

export default {
  name: "SellerDiscountCoupon",
  metaInfo: {
    title: 'ایوان خانه- کوپن تخفیف',
  },
  components: {BackBar},
  data: () => ({
    openEditBottomSheet: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    defineCouponTab: true,
    listCouponTab: false,
    maxUse: 0,
    discount: 0,
    discountCodeID: null,
    typeDiscount: null,
    friends: [],
    name: 'Midnight Crew',
    people: [],
    pageIndex: 1,
    pageSize: 2,
    items: [
      {id: 'عمومی', text: 'عمومی'},
      {id: 'دنبال_کنندگان', text: 'دنبال کنندگان'},
      {id: 'دنبال_کننده_خاص', text: 'دنبال کننده خاص'},
    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    inputDate: '',
    menu: false,
    menu2: false,
    searchKeyWord: null,
    loadMoreCoupons: false,
    editCouponModal: false,
    menu2Dialog: false,
    inputDateDialog: '',
    dateDialog: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    vendorId: null,
    count: 1,
    editMaxUse: null,
    editExpireDate: null,
    editVendors: null,
    editVendorID: null,
    editVendorFollowers: null,
    editVendorFollowerIDs: null,
    editTypeDiscount: null,
    editDiscountCode: null,
    editDiscount: null,
    editCount: null,
    typeDiscountCode: ['', 'عمومی', 'دنبال کنندگان', 'دنبال کننده خاص'],
    hasResult: true,
    hasCouponList: true,
    couponsList: [],
    allList: [],
    couponID: null
  }),
  mounted() {
    this.getAddCouponData()
    this.getCouponsList()
  },
  methods: {
    showDefineCouponTab() {
      this.defineCouponTab = true;
      this.listCouponTab = false
    },
    showListCouponTab() {
      this.defineCouponTab = false;
      this.listCouponTab = true
    },
    remove(item) {
      const index = this.friends.indexOf(item.Value)
      if (index >= 0) this.friends.splice(index, 1)
    },
    inputDatePicker() {
      this.menu2 = false
      this.inputDate = moment(this.date).format('jYYYY/jMM/jDD')
    },
    getAddCouponData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/DiscountManagement/_Define", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.people = json.VendorFollowers;
            this.discountCodeID = json.DiscountCodeID
            this.vendorId = json.VendorID
            this.maxUse = json.MaximumUseNumber;

          })
          .catch(error => console.log('error', error));
    },
    getCouponsList() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/DiscountManagement/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.couponsList = json
            this.allList = json
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    registerDiscountCoupon() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeDiscount", this.typeDiscount);
      urlencoded.append("Discount", this.discount);
      urlencoded.append("MaximumUseNumber", this.maxUse);
      urlencoded.append("ExpireDate", this.inputDate);
      urlencoded.append("Count", this.count);
      urlencoded.append("VendorID", this.vendorId);
      let followers = this.friends
      for (let i = 0; i < followers.length; i++) {
        urlencoded.append("VendorFollowerIDs", followers[i]);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "VendorPanel/DiscountManagement/_Define", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.resultText = JSON.parse(result).Message
              location.reload()
            } else {
              this.resultText = result
            }
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    removeSearchHistory() {
      this.couponsList = this.allList
      this.hasResult = true
    },
    search() {
      let result = this.couponsList.filter(x => x.CodeNumber.includes(this.searchKeyWord));
      if (this.searchKeyWord === '') {
        this.couponsList = this.allList
      } else {
        if (result.length === 0) {
          this.hasResult = false
        } else {
          this.hasResult = true
          this.couponsList = result
        }
      }
    },
    openEditCoupon(id) {
      this.couponID = id
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/DiscountManagement/_Edit?DiscountCodeID=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            this.editMaxUse = json.MaximumUseNumber;
            this.inputDateDialog = this.$convertDate(json.ExpireDate);
            this.editCount = json.Count;
            this.editDiscount = json.Discount;
            this.editDiscountCode = json.DiscountCodeID;
            this.editTypeDiscount = json.TypeDiscount;
            this.editVendorFollowerIDs = json.VendorFollowerIDs;
            this.editVendorFollowers = json.VendorFollowers;
            this.editVendorID = json.VendorID;
            this.editVendors = json.Vendors
            this.openEditBottomSheet = true
          })
          .catch(error => console.log('error', error));
    },
    inputDatePickerDialog() {
      this.menu2Dialog = false
      this.inputDateDialog = moment(this.dateDialog).format('jYYYY/jMM/jDD')
    },
    editCoupon() {
      this.openEditBottomSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("DiscountCodeID", this.editDiscountCode);
      urlencoded.append("TypeDiscount", this.$TypeDiscount(this.editTypeDiscount));
      urlencoded.append("Discount", this.editDiscount);
      urlencoded.append("MaximumUseNumber", this.editMaxUse);
      urlencoded.append("ExpireDate", this.inputDateDialog);
      urlencoded.append("Count", this.editCount);
      urlencoded.append("VendorID", this.editVendorID);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "VendorPanel/DiscountManagement/_Edit", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.resultText = JSON.parse(result).Message
              this.getCouponsList()
              this.defineCouponTab = false
              this.listCouponTab = true
            } else {
              this.resultText = result
            }
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    }


  }
}
</script>

<style scoped>

</style>
